<template>
  <card>
    <list
      :params="params"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="false"
      :itemLink="itemLink"
      :filters="filters"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
      :setImport="true"
      :exportFields="exportFields"
    />
  </card>
</template>
  <script>
export default {
  name: "groups",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      exportFields: {
        "ID Ученика": "id",
        ФИО: "full_name",
        Рейтинг: "average_rating",
        Класс: {
          field: "group",
          callback: (value) => {
            return value && value[0] ? value[0]["title"] + " класс" : "Нет";
          },
        },
      },
      params: {},
      val: [],
      modalCreate: "group",
      fields: [],
      /** APIs */
      removeLink: "",
      cardLink: "item_group",
      itemLink: "business/rating/clients",
      setLink: "business/rating/clients",
      columns: [
        {
          key: "id",
          title: "Login",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        // {
        //   key: "average_rating",
        //   title: "Ср. бал",
        //   checkbox: false,
        //   control: false,
        //   align: "left",
        //   timer: false,
        //   detail: false,
        // },
        // {
        //   key: "sum_rating",
        //   title: "Рейтинг",
        //   checkbox: false,
        //   control: false,
        //   align: "left",
        //   timer: false,
        //   detail: false,
        // },
        {
          key: "sum_points",
          title: "Рейтинг",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "full_name",
          title: "Ученик",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "group",
          title: "Класс",
          object: "title",
          disableLink: true,
        },
        {
          key: "phone",
          title: "Номер телефона",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
      ],
      filters: [
        {
          key: "season",
          title: "Сезон",
        },
        {
          key: "group",
          title: "Группа",
        },
      ],
    };
  },
};
</script>
  <style>
</style>
  